module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput.checkbox,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "最少选择限制",
      "prop": "select_min"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.curInput.checkbox.select_min),
      expression: "curInput.checkbox.select_min",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.curInput.checkbox.select_min)
    },
    on: {
      "input": function($event) {
        _vm.curInput.checkbox.select_min = _vm._n($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("填0代表不限制")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "最多选择限制",
      "prop": "select_max"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.curInput.checkbox.select_max),
      expression: "curInput.checkbox.select_max",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.curInput.checkbox.select_max)
    },
    on: {
      "input": function($event) {
        _vm.curInput.checkbox.select_max = _vm._n($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("填0代表不限制")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否显示全选",
      "prop": "show_select_all"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.checkbox.show_select_all),
      expression: "curInput.checkbox.show_select_all"
    }],
    domProps: {
      "value": (_vm.curInput.checkbox.show_select_all)
    },
    on: {
      "input": function($event) {
        _vm.curInput.checkbox.show_select_all = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])])]), _vm._v(" "), _c('option-config', {
    attrs: {
      "curInput": _vm.curInput,
      "selectConfig": _vm.curInput.checkbox_option,
      "onlyName": true,
      "chooseMultiply": true,
      "maxCount": _vm.curInput.checkbox.select_max
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-207788fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/checkboxConfig.vue
// module id = 1791
// module chunks = 2